export default "__VITE_ASSET__DWcPNRX2__"